import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  AppData,
  BackupFrequency,
  PrimaryStorage,
  UserData,
  UserMetaData,
} from './authTypes';

export interface AuthState {
  temporaryUser?: UserMetaData;
  user: UserData;
  app: AppData;
}

const userInitialState = {
  id: '',
  username: '',
  email: '',
  fullname: '',
};

export const authAppInitialState = {
  localBackups: false,
  // dirPermission: false,
  // isMasterTab: false,
  primaryStorage: PrimaryStorage.IndexedDB,
  backupFrequency: BackupFrequency.Weekly,
};

const initialState: AuthState = {
  user: userInitialState,
  app: authAppInitialState,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    toggleMasterTab: (state, action: PayloadAction<boolean>) => {
      state.app.isMasterTab = action.payload;
    },
    addAuth: (state, action: PayloadAction<AuthState>) => {
      return action.payload;
    },
    updateAuthUser: (state, action: PayloadAction<UserData>) => {
      state.user = action.payload;
    },
    updateAuthApp: (state, action: PayloadAction<AppData>) => {
      state.app = action.payload;
    },
    removeAuthUser: (
      state,
      action: PayloadAction<UserMetaData | undefined>
    ) => {
      return {
        temporaryUser: action.payload,
        user: userInitialState,
        app: authAppInitialState,
      };
    },
  },
});

export const {
  toggleMasterTab,
  addAuth,
  updateAuthUser,
  updateAuthApp,
  removeAuthUser,
} = authSlice.actions;
export default authSlice.reducer;
